import React from 'react';

const tableLinkStyles = { color: '#006da6', cursor: 'pointer' };

function TableLinkComponent({
  value = '',
  onClick = () => {},
  underline = false,
}) {
  return (
    <span
      style={tableLinkStyles}
      onClick={onClick}
      className={underline ? 'text-decoration-underline' : ''}
    >
      {value}
    </span>
  );
}

export default TableLinkComponent;
